import EventHandler from '@pixelunion/events';

export default class Tabs {
  constructor() {
    this.tabs = document.querySelectorAll('ul.tabs');
    this.events = new EventHandler();

    if (!this.tabs) { return; }

    this.tabs.forEach(tabs => {
      this.events.register(tabs, 'click', event => {
        event.preventDefault();
        const { target } = event;
        const sibling = tabs.nextElementSibling;

        if (!sibling) { return; }

        if (target.nodeName === 'A') {
          this.displaySelected(target, tabs, sibling);
        }
      });
    });
  }

  displaySelected(target, tabs, sibling) {
    const tabsPresent = tabs.querySelectorAll('li a');
    const tabsContentPresent = sibling.querySelectorAll('ul.tabs-content > li');

    for (let i = 0; i < tabsPresent.length; i++) {
      tabsPresent[i].classList.remove('active');
      tabsContentPresent[i].classList.remove('active');

      if (target === tabsPresent[i]) {
        tabsPresent[i].classList.add('active');
        tabsContentPresent[i].classList.add('active');
      }
    }
  }
}
